import type { LotTitleType } from "../api/lots";

export const DEFAULT_TITLE_TYPE: LotTitleType = "TCT";

export const TITLE_TYPE_METADATA: Record<
  LotTitleType,
  { label: string; description: string }
> = {
  TCT: {
    label: "Transfer Certificate of Title",
    description:
      "Issued when ownership transfers from the original title holder; default for land parcels.",
  },
  OCT: {
    label: "Original Certificate of Title",
    description: "First registration of a parcel under the Torrens system.",
  },
  CCT: {
    label: "Condominium Certificate of Title",
    description:
      "Covers condominium units or air-rights spaces rather than full land parcels.",
  },
};

export const TITLE_TYPE_ORDER: LotTitleType[] = ["TCT", "OCT", "CCT"];

export const TITLE_TYPE_SELECT_OPTIONS = TITLE_TYPE_ORDER.map((value) => ({
  value,
  label: `${TITLE_TYPE_METADATA[value].label} (${value})`,
}));

export function isLotTitleType(value: string): value is LotTitleType {
  return TITLE_TYPE_ORDER.includes(value as LotTitleType);
}

export function normalizeTitleType(
  value?: string | null,
): LotTitleType {
  if (!value) {
    return DEFAULT_TITLE_TYPE;
  }
  const normalized = value.toUpperCase();
  return isLotTitleType(normalized) ? (normalized as LotTitleType) : DEFAULT_TITLE_TYPE;
}

export function formatTitleTypeDisplay(type: LotTitleType): string {
  return `${TITLE_TYPE_METADATA[type].label} (${type})`;
}
